import { LANGUAGE_VALUE } from './selectLists/languagesList'

export const defaultLocale = LANGUAGE_VALUE.EN

export const LANGUAGE = 'language'

// be store languages with their own values
export const BE_LANGUAGE_VALUE = {
  [LANGUAGE_VALUE.EN]: 'en-us',
  [LANGUAGE_VALUE.UA]: 'uk-uk'
}
